import { render } from "./Search.vue?vue&type=template&id=74be3b27&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=74be3b27&scoped=true&lang=css"
import "./Search.vue?vue&type=style&index=1&id=74be3b27&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74be3b27"]])

export default __exports__